import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (planzone) =>
    present(
      repository
        .getProjectModels(planzone)
        .then((projectModels) => ({ projectModels, planzone }))
        .catch((e) => Promise.reject(planzone)),
    );
}

export type { Interactor };

export { createInteractor };
